import React, { useState } from 'react';
import EditarSolicitacao from '../../AcompanharSolcitacao/EditarSolicitacao';

import ResumoAgendamento from '../../AcompanharSolcitacao/ResumoAgendamento';

const CasosDeReparo = ({
  tema,
  novoAgendamento,
  apontamentoSelecionado,
  setApontamentoSelecionado,
  reparos,
  setReparos,
  listaDeImoveis,
  executeScroll,
  setEntendiConcordo,
  entendiConcordo,
  loadingTentativaAgendamento,
  isSindico,
}) => {
  const [showAddReparoPopup, setShowAddReparoPopup] = useState(false);
  return (
    <EditarSolicitacao
      novoAgendamento={novoAgendamento}
      tema={tema}
      apontamentoSelecionado={apontamentoSelecionado}
      setApontamentoSelecionado={setApontamentoSelecionado}
      reparos={reparos}
      setReparos={setReparos}
      listaDeImoveis={listaDeImoveis}
      executeScroll={executeScroll}
      isSindico={isSindico}
      setEntendiConcordo={setEntendiConcordo}
      entendiConcordo={entendiConcordo}
      loadingTentativaAgendamento={loadingTentativaAgendamento}
      showAddReparoPopup={showAddReparoPopup}
      setShowAddReparoPopup={setShowAddReparoPopup}
    >
      <ResumoAgendamento
        reparos={reparos}
        tema={tema}
        novaSolicitacao
        setReparos={setReparos}
        isSindico={isSindico}
      />
    </EditarSolicitacao>
  );
};

export default CasosDeReparo;
